import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import api from "../api/axiosConfig";
import TopicWiseCourse from "./TopicWiseCourse";
import CourseLibrary from "./CourseLibrary";

function MyCourse() {
  const { courseId } = useParams();
  const [classroom, setClassroom] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    api
      .get(`/learn/${courseId}`)
      .then((res) => {
        if (cancelled) return;
        setClassroom(res.data);
        setError("");
      })
      .catch((err) => {
        if (cancelled) return;
        setClassroom(null);
        setError(err.response?.data?.message || "Unable to load this course.");
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [courseId]);

  if (loading) {
    return <p className="text-center py-5">Loading course...</p>;
  }

  if (!classroom?.course) {
    return (
      <main className="section-space">
        <div className="container">
          <p>{error || "This course is not in your purchases."}</p>
          <Link to={`/courses/${courseId}`}>Back to course</Link>
        </div>
      </main>
    );
  }

  const { course, topics, videos, testSeries } = classroom;
  const isLibrary =
    course.courseType === "subject-wise" || course.courseType === "full-length";

  return (
    <main className="section-space my-course-page">
      <div className="container">
        <p className="my-course-back">
          <Link to="/dashboard?tab=courses">← Courses purchased</Link>
        </p>
        <h1 className="my-course-title">{course.title}</h1>

        {course.courseType === "topic-wise" ? (
          <TopicWiseCourse
            course={course}
            topics={topics || []}
            testSeries={testSeries || []}
          />
        ) : null}

        {isLibrary ? (
          <CourseLibrary
            course={course}
            videos={videos || []}
            testSeries={testSeries || []}
          />
        ) : null}
      </div>
    </main>
  );
}

export default MyCourse;
